(() => {
  const money = (cents, currency) => new Intl.NumberFormat('en-ZA', { style: 'currency', currency: currency || 'ZAR' }).format(cents / 100);
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  function updateBundleValue(scope, variant, quantity, currency) {
    scope.querySelectorAll('[data-pm6-bundle-value]').forEach(card => {
      const separate = Number(card.dataset.separateTotal);
      const saving = Math.max(0, separate - variant.price);
      card.querySelector('[data-pm6-bundle-saving-row]').hidden = !(separate > 0 && saving > 0);
      setText(card.querySelector('[data-pm6-bundle-saving]'), money(saving * quantity, currency));
      setText(card.querySelector('[data-pm6-bundle-percentage]'), String(separate > 0 ? Math.round(saving / separate * 100) : 0));
      card.querySelector('[data-pm6-bundle-shipping]').hidden = variant.price * quantity < Number(card.dataset.freeShipping || 70000);
    });
  }
  function updateEstimate(widget) {
    const form = document.getElementById(widget.dataset.pm6BuyForm);
    if (!form) return;
    const scope = form.closest('.pm3-native-product') || form;
    const id = form.querySelector('[name="id"]')?.value;
    const variants = JSON.parse(widget.querySelector('[data-pm6-prices]').textContent);
    const variant = variants.find(row => String(row.id) === String(id));
    if (!variant) return;
    const quantityInput = scope.querySelector('input[name="quantity"]');
    const quantity = Number(quantityInput?.value || 1);
    if (!Number.isFinite(quantity) || quantity < 1) return;
    setText(widget.querySelector('[data-pm6-total]'), money(variant.price * quantity, widget.dataset.currency));
    const compare = widget.querySelector('[data-pm6-compare]');
    if (compare) {
      compare.hidden = !(variant.compare > variant.price);
      setText(compare, money(variant.compare * quantity, widget.dataset.currency));
    }
    const compareLabel = widget.querySelector('[data-pm6-compare-label]');
    if (compareLabel) compareLabel.hidden = compare?.hidden !== false;
    updateBundleValue(widget, variant, quantity, widget.dataset.currency);
    form.querySelectorAll('[data-pm6-buy-now]').forEach(button => {
      const primary = form.querySelector('[name="add"]');
      button.disabled = primary?.disabled || !variant.available;
    });
  }
  function updateHomePrice(form) {
    const source = form.querySelector('[data-pm6-prices]');
    if (!source) return;
    const variant = JSON.parse(source.textContent).find(row => String(row.id) === form.querySelector('[name="id"]')?.value);
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    if (!variant || !Number.isFinite(quantity) || quantity < 1) return;
    const price = form.parentElement.querySelector('[data-pm3-price]');
    setText(price?.querySelector('[data-pm6-current]'), money(variant.price * quantity, form.dataset.currency));
    const compare = price?.querySelector('[data-pm6-compare]');
    if (compare) { compare.hidden = !(variant.compare > variant.price); setText(compare, money(variant.compare * quantity, form.dataset.currency)); }
    const compareLabel = price?.querySelector('[data-pm6-compare-label]');
    if (compareLabel) compareLabel.hidden = compare?.hidden !== false;
    updateBundleValue(form.parentElement, variant, quantity, form.dataset.currency);
  }
  function init(root = document) {
    root.querySelectorAll('.pm3-purchase[data-pm6-product-url]').forEach(form => {
      if (form.dataset.pm6Ready) return;
      form.dataset.pm6Ready = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.pm6Busy) return;
        const button = form.querySelector('[data-pm3-submit]');
        if (button?.disabled || !form.reportValidity()) return;
        form.dataset.pm6Busy = 'true';
        button.disabled = true;
        const error = form.querySelector('[data-pm6-error]');
        if (error) { error.hidden = true; setText(error, ''); }
        try {
          const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || form.dataset.pm6Error);
          const destination = new URL(form.dataset.pm6ProductUrl, window.location.origin);
          destination.searchParams.set('variant', form.querySelector('[name="id"]').value);
          window.location.assign(destination.pathname + destination.search);
        } catch (failure) {
          if (error) { error.hidden = false; setText(error, failure.message || form.dataset.pm6Error); }
          button.disabled = false;
          delete form.dataset.pm6Busy;
        }
      });
      form.addEventListener('input', () => updateHomePrice(form));
      form.addEventListener('change', () => requestAnimationFrame(() => updateHomePrice(form)));
      updateHomePrice(form);
    });
    document.querySelectorAll('[data-pm6-estimate]').forEach(updateEstimate);
  }
  let pending = false;
  const refresh = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; init(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('input', event => { if (event.target.matches('[name="quantity"]')) refresh(); });
  document.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.closest?.('.pm3-native-product'))) refresh();
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
})();
